export default "<svg viewBox=\"0 0 1296 215\" fill=\"var(--link-color)\" xmlns=\"http://www.w3.org/2000/svg\"/>";